import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Department} from "../../models/Department"

export const departmentFields: IntercateKeysMap<Department, EntityField<Department>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id sektora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Ime sektora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Opis sektora",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    parentId: {
		name: "parentId", dataType: EntityFieldDataType._reference, label: "Nadređeni sektor",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Departments
		},
		validator: { required: false },
		sortable: true
	},
}

const departmentFieldsArray: Array<EntityField<Department>> = [
	departmentFields.title,
	departmentFields.description,
	departmentFields.parentId,
]

export const departmentFieldsDescriptor: EntityFieldsDescriptor<Department> = {
	listFields: departmentFieldsArray,
	createFormFields: departmentFieldsArray,
	updateFormFields: departmentFieldsArray
}